import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { sanitizeRichText } from "../../../../utils/sanitizeRichText";

const stripHtml = (html: string) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
};

const HtmlTruncateWithTooltip = ({ html, limit = 20, className = "text-gray-700" }: any) => {
    const textOnly = stripHtml(html);

    const shortText =
        textOnly.length > limit ? textOnly.substring(0, limit) + "..." : textOnly;

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="desc-tooltip" className="custom-tooltip p-6 p-md-0">
                    <div dangerouslySetInnerHTML={{ __html: sanitizeRichText(html) }} />
                </Tooltip>
            }
        >
            <div className={`${className}`}>
                {shortText}
            </div>
        </OverlayTrigger>
    );
};

export { HtmlTruncateWithTooltip };